import Vue from "vue";
import api from "@/api";

export default {
	actions: {
		async UploadSingleFile(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UploadSingleFile,
				data: entry,
			});
			return response.data;
		},
	},
};
